import { turnPageHandler } from "@/helper/dataHelper";

import { StoreAction, StoreActionTypes, StoreState } from "./storeTypes";

const initialState: StoreState = {
  list: [],
  store: {
    createdAt: "2020-08-21T02:27:55.804Z",
    id: 0,
    lastTrialDate: "2020-08-21T02:27:55.804Z",
    lastPaymentHistory: {
      amount: 0,
      createdAt: "2020-08-21T02:27:55.804Z",
      description: "string",
      id: 0,
      item: "string",
      invoiceNo: "",
      historyType: "DEPOSIT",
      paymentGatewayTxId: "string",
      paymentStatus: "OK",
      tapPayCardInfo: {
        binCode: "string",
        country: "string",
        countryCode: "string",
        createdAt: "2020-08-21T02:27:55.804Z",
        funding: 0,
        id: 0,
        issuer: "string",
        lastFour: "string",
        level: "string",
        type: 0,
      },
    },
    logoPhotoFile: {
      contentType: "string",
      id: 0,
      name: "string",
      relateType: "GROUP",
      relateTypeId: 0,
      url: "string",
    },
    name: "string",
    nextPaymentDateTime: "2020-08-21T02:27:55.804Z",
    nextPlan: {
      id: 0,
      name: "string",
      period: "MONTH",
      price: 0,
      status: "ON",
    },
    plan: {
      id: 0,
      name: "string",
      period: "MONTH",
      price: 0,
      status: "ON",
    },
    planExpireDateTime: "2020-08-21T02:27:55.804Z",
    point: 0,
    status: "ON",
    tapPayCardInfo: {
      binCode: "string",
      country: "string",
      countryCode: "string",
      createdAt: "2020-08-21T02:27:55.804Z",
      funding: 0,
      id: 0,
      issuer: "string",
      lastFour: "string",
      level: "string",
      type: 0,
    },
  },
  smsList: [],
  paymentLog: {
    atPage: 0,
    items: [],
    totalCount: 0,
    totalPages: 0,
  },
  pointLog: {
    atPage: 0,
    items: [],
    totalCount: 0,
    totalPages: 0,
  },
};

const storeReducer = (
  state = initialState,
  action: StoreAction
): StoreState => {
  switch (action.type) {
    case StoreActionTypes.GET_STORE_LIST:
      return { ...state, list: action.payload };
    case StoreActionTypes.GET_STORE_DETAIL:
      return { ...state, store: action.payload };
    case StoreActionTypes.GET_ALL_STORE_SMS_STATUS_DETAIL:
      return { ...state, smsList: action.payload };
    case StoreActionTypes.GET_STORE_SMS_STATUS_DETAIL:
      return { ...state, sms: action.payload };
    case StoreActionTypes.PUT_STORE_PLAN:
      return { ...state, store: action.payload };
    case StoreActionTypes.DELETE_STORE_PLAN:
      return { ...state, store: action.payload };
    case StoreActionTypes.POST_SEARCH_PAYMENT_HISTORY:
      return {
        ...state,
        paymentLog: turnPageHandler(state.paymentLog, action.payload),
      };
    case StoreActionTypes.POST_SEARCH_POINT_HISTORY:
      return {
        ...state,
        pointLog: turnPageHandler(state.paymentLog, action.payload),
      };
    default:
      return state;
  }
};

export default storeReducer;
